export class NameBuilderConfiguration {
    hasGroupName: boolean = false;
    hasName: boolean = true;
    hasShortComment: boolean = false;
    hasTagShortComment?: boolean = false;
    hasUnit: boolean = false;
    hasValueType: boolean = false;
    hasOffset?: boolean = false;
    forceName?: boolean;

    constructor(hasName?: boolean, hasGroupName?: boolean, hasShortComment?: boolean, hasUnit?: boolean, hasValueType?: boolean, hasTagShortComment?: boolean) {
        this.hasName = hasName ? hasName : this.hasName;
        this.hasGroupName = hasGroupName ? hasGroupName : this.hasGroupName;
        this.hasShortComment = hasShortComment ? hasShortComment : this.hasShortComment;
        this.hasTagShortComment = hasTagShortComment ? hasTagShortComment : this.hasTagShortComment;
        this.hasUnit = hasUnit ? hasUnit : this.hasUnit;
        this.hasValueType = hasValueType ? hasValueType : this.hasValueType;
    }
}